<template>
  <LMap @ready="mapLoad" :center="[47, 2]" ref="map" :zoom="6" style="height: 93vh">
    <LTileLayer :url="url" />
    <LFeatureGroup ref="markergroup">
     <v-marker-cluster>
          <template v-for="(station, i) in user.stations">
          <LMarker
            @click="$router.push(`/stations/${station.id_station}`)"
            :key="i"
            v-if="station && station.last_data"
            :lat-lng="[station.latitude, station.longitude]"
          >
            <LIcon iconSize="150">
              <template v-if="station.last_data">
                <v-chip color="white" v-if="!station.last_data.error">
                  <v-icon v-if="!station.last_data[0].rain"></v-icon> 
                  <v-icon v-else>mdi-weather-rainy</v-icon>   
  
                  {{station.last_data[0].temp}}°C 
                  <template v-if="station.last_data[0].wind">
                    | 
                    {{Math.round(station.last_data[0].wind * 3.6)}}km/h
                  </template>
                  </v-chip>
                  <v-chip color="error" v-else><v-icon>mdi-close</v-icon> No data</v-chip>
              </template>
              <!-- <v-btn x-small fab :color="station.last_data.error ? 'error' : 'white'"
                ><v-icon x-small color="primary">mdi-wifi</v-icon></v-btn
              > -->
            </LIcon>
          </LMarker>
        </template>
          
        </v-marker-cluster>
      </LFeatureGroup>
      <LControl position="bottomright">
        <v-btn rounded to="/stations/create"> <v-icon>mdi-
        plus</v-icon> Ajouter une station </v-btn>
      </LControl>
  </LMap>
</template>

<script>
import { mapState } from "vuex";
import { LMap, LTileLayer, LMarker, LIcon, LControl, LFeatureGroup } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

export default {
  computed: {
    ...mapState(["user"]),
  },
  methods:{
    mapLoad()
    {
      console.log('Map ready'); 
      console.log(this.$refs.markergroup.mapObject.getBounds());
      this.$refs.map.mapObject.fitBounds(this.$refs.markergroup.mapObject.getBounds())
    }
  },
  components: {
    LMap,
    LTileLayer,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    LFeatureGroup,
    LMarker,
    LIcon,
    LControl,
  },
  data: () => ({
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  }),
};
</script>

<style>
</style>